module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "chno"
  }, [_vm._v("QUESTION 2")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Do the Gospels Present an Accurate Description of the Life of Jesus?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("alk about the quest for the historical Jesus might imply that the church has lost the Jesus behind the Gospels. Indeed, that is the conclusion that numerous New Testament scholars have reached over the last two hundred years. This issue boils down to whether or not the four gospels are historically reliable. Those who do not think the Gospels are historically reliable are skeptical that Christianity can ever recover who the real Jesus was and what he did, if anything! However, conservative scholars disagree, arguing instead that the portraits of Jesus in the New Testament gospels are accurate because they are the inspired word of God and also are supported by the historical facts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("So the fundamental query which concerns this opening unit of our book is this: Is the Jesus of history the same as the Christ of faith? In other words, has the later church made Jesus of Nazareth into something other than he actually was on earth? Or was he the Messiah, the Son of God who inaugurated the kingdom of God by performing miracles, revealing God, dying for our sin, and then was raised from the dead? We will attempt to answer these all-important questions by documenting and then responding to the three major criticisms that have been brought against the historical reliability of the four gospels. Those criticisms are, in their basic historical order of appearance, as follows: (1) The four gospels present Jesus as performing supernatural feats, which no scientifically-informed person thinks is possible. (2) The four gospels repeatedly contradict themselves as well as commit historical errors thus undermining their trustworthiness. (3) The three key New Testament disciplines of source, form, and redaction criticisms have combined to refute the claim of the Gospels that they are based on eyewitness accounts.")])]), _c('h1', {
    staticClass: "sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Rejection Due to Miracles")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("First, perhaps the oldest criticism raised against the historical reliability of the canonical gospels was, and continues to be, that of skepticism toward the miracles they record. With the entrenchment of the Enlightenment from the sixteenth to eighteenth centuries came a rejection of the supernatural. Such an anti-supernatural bias found its way especially in the polemical writings of David Hume, the Scottish philosopher who rejected the reliability of the Gospels because they purported that Jesus performed miracles. Hume claimed that the probability would be greater for a natural rather than supernatural explanation of any apparently miraculous event. To substantiate this claim, Hume offered four lines of support. (1) No alleged miracle has been ever supported with the testimony of a sufficiently large number of witnesses. (2) People in general crave the miraculous and believe fables more readily than they ought. (3) Miracles occur only among barbarous people. (4) Miracle stories occur in all religions and thereby cancel each other out since they support irreconcilable doctrines."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_1",
      "id": "fnote-1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such skepticism toward the miracles of Jesus as recorded in the Gospels influenced President Thomas Jefferson to compose his version of the four gospels, which cut out anything that contained the supernatural! Prejudice against the supernatural aspect of the Gospels was championed by eighteenth- to nineteenth-century biblical scholars from Friedrich Schleiermacher to David F. Strauss to J. Ernest Renan. In the twentieth and twenty-first centuries, notable New Testament scholars like Rudolph Bultmann, the Fellows of the Jesus Seminar, and Bart Ehrman have continued the attacks on the supernatural claims made by the four gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The underlying premise of these anti-supernatural scholars is that the universe is a closed system based on natural causes proceeding from inviolable laws of science. This presupposition is fundamentally opposed to the suspension of such laws due to divine intervention. Added to this is Ernst Troeltsch’s principle of historical analogy, which essentially declares that we cannot accept reports of miracles in the past because we know that miracles do not happen in the present. The combination of the aforementioned anti-supernatural bias with the principle of historical analogy produced what is commonly called today, the “historical-critical method.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What are we to say to this closed view of the universe that regards the miraculous in the Gospels with deep suspicion? Two responses rightly counter this mindset. First, the commonality of the previous skeptical scholars is that they are restricted to a provincial Western mentality. As Paul Rhodes Eddy and Gregory A. Boyd note, such a viewpoint does not objectively take into account the miraculous phenomena occurring in non-Western cultures "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("reported by even Western ethnographers. These include encounters with angels and demons, experiences of instantaneous healings, deceased people coming back to life, and more. The authors write, “Clearly, outside the narrow experience of secularized Western scholars, present human experience is not by any means devoid of the supernatural.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_2",
      "id": "fnote-2"
    }
  }, [_vm._v("2")]), _vm._v(" Second, it is an undeniable fact that the majority of Western people have never stopped believing in, and occasionally experiencing, what they perceive to be supernatural occurrences."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_3",
      "id": "fnote-3"
    }
  }, [_vm._v("3")])]), _vm._v(" Eddy and Boyd observe that the Gallup polls and others reveal that eighty percent of Americans believe that God performs miracles today."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_4",
      "id": "fnote-4"
    }
  }, [_vm._v("4")])]), _vm._v(" And we might add to this that the scientific community itself has long-since replaced the antiquated view of the inviolability of the laws of Newtonian mechanics with quantum theory in which natural “laws” are recognized as only provisional descriptions of observed regularities in nature."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_5",
      "id": "fnote-5"
    }
  }, [_vm._v("5")])]), _vm._v(" Not long ago I heard a distinguished Harvard physics professor announce that his experimentations worked nine out of ten times, which in his estimation still left room for divine intervention in at least one out of ten times!")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("Supposed Internal Contradictions and Historical Errors")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second, for years now skeptics of the Gospels have asserted that they are filled with internal contradictions and historical errors. Thus, Craig Blomberg writes, “Because the New Testament has been scrutinized with more intensity than any other work of literature in the history of the world, it is not surprising to discover that virtually every passage in the Gospels has been seen as conflicting with some other passage by someone or other at some time in history.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_6",
      "id": "fnote-6"
    }
  }, [_vm._v("6")])]), _vm._v(" We will now engage these two arguments in order.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Supposed Internal Contradictions")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Regarding the supposed internal contradictions, the reality is that when four points are kept in mind the apparent contradictions in the Gospels evaporate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("Literary Arrangement.")]), _vm._v(" Literary arrangement explains many notable “discrepancies” in the Gospels such as the different orders of the wilderness temptations of Christ in Matthew and Luke, the timing of the cleansing of the Jerusalem "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("temple by Christ, or the question of whether Jesus celebrated the Passover on the night before he was arrested and crucified. Ancient authors, like modern writers, exercised poetic liberty in rearranging the chronological order of the events of a person’s life for the purpose of dramatic presentation. The Statement on Inerrancy of the Evangelical Theological Society agrees, arguing that the gospel authors’ literary rearrangement of the chronology of the life of Jesus for their purposes of presentation in no way detracts from the inspired nature of the message of the Gospels."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_7",
      "id": "fnote-7"
    }
  }, [_vm._v("7")]), _vm._v(" This is just good writing at work. As an example, we may apply this technique to the first of the preceding examples. It is true that Matthew and Luke present the temptations of Jesus in somewhat different order. Thus:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdhead"
  }, [_c('p', {
    staticClass: "t-lefta"
  }, [_c('strong', [_vm._v("MATTHEW 4:1–11")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdhead"
  }, [_c('p', {
    staticClass: "t-lefta"
  }, [_c('strong', [_vm._v("LUKE 4:1–13")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1) Stones to Bread")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1) Stones to Bread")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2) Temple")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("2) Kingdoms of the World")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("3) Kingdoms of the World")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("3) Temple")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most likely, Luke has the more original order than Matthew as is evidenced, for example, by the first evangelist’s propensity to organize his material around the theme of Jesus as the new Moses (note how Matthew clusters the Sermon on the Mount material together to attain that purpose rather than Luke’s Sermon on the Plain in Luke 6:17–49). Matthew attaches high value to mountains as the place of divine revelation,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_8",
      "id": "fnote-8"
    }
  }, [_vm._v("8")])]), _vm._v(" which is why he lists as last Satan’s temptation of Jesus on a mountain. It was on that mountain that Jesus rejected Satan’s offer of the kingdoms of the world if, that is, Jesus would worship him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("Theological Considerations.")]), _vm._v(" Second, related to the previous point, theological considerations contributed to the varying literary arrangements found among the four gospels. For example, Matthew portrays Jesus as the new Moses. Mark reveals that Jesus is the suffering Messiah through four passion predictions (Mark 8–10). Luke’s extended treatment of Jesus’ journey to Jerusalem to be crucified is similar to one of Israel’s rejected prophets (Luke 9–19). John presents Jesus as the true Israel who replaced or fulfilled the Old Testament feasts, sacrifices, and temple. The canonical gospel writers organized their respective material to convey the spiritual message the Holy Spirit impressed upon them. Thus, literary arrangement and theological considerations go hand in hand with dismissing apparent contradictions among the Gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('strong', [_vm._v("Cultural Adaptation.")]), _vm._v(" Cultural adaptation also explains different descriptions in the Gospels of the same words and deeds of Jesus. For example, Luke famously changes the imagery of his narrative from something distinctively Palestinian to its Greco-Roman counterpart. Three examples will suffice to demonstrate this interpretation of the other synoptic gospels. Blomberg records these instances of cultural adaptation:")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("In at least three clear cases, as he writes for the least Jewish audience of all the gospels and with the most fluent Greek style of the four, Luke changes the imagery of his narrative from something distinctively Palestinian to its Graeco-Roman counterpart. The parable of the two builders is the most developed example of this process of “representational change” (Matt. 7:24–27; Luke 6:47–49). Luke adds that the wise man who built his house on the rock “dug down deep and laid the foundation”, a practice much more common outside Palestine than within, and turns the description of the storm with its violent wind appropriate for the small, dry Israeli desert river beds suddenly swollen with rain, into a calmer flood, more characteristic of a larger river such as the Syrian Orontes slowly overflowing its banks. So, too, only Luke’s version of the parable of the mustard seed has the plant growing in a garden rather than a field (Luke 13:19; cf. Mark 4:31; Matt. 13:31). Jewish purity laws forbade the planting of a mustard seed in a garden, but in the Graeco-Roman world this was a common place practice. And Luke’s account of the lowering of the paralytic through the roof of the house where Jesus was teaching removes Mark’s reference to “digging”, which would have been necessary with the typical thatched roofs of Palestine, and replaces it with a description of the removal of “tiles”, more common atop buildings elsewhere in the Roman Empire (Mark 2:4; Luke 5:19). All these changes simply help a non-Jewish audience to picture the scenes more vividly and comprehensibly in their minds, even if the actual details of the imagery have changed."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_9",
      "id": "fnote-9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('strong', [_vm._v("Corroborating Reports.")]), _vm._v(" More than agreement in every little detail, corroborating reports also dismiss apparent contradictions among the Gospels. Thus, on the one hand, the birth narratives of Jesus Christ as recorded in Matthew 1–2 and Luke 1–2 contain differing material:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdhead"
  }, [_c('p', {
    staticClass: "t-lefta"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('strong', [_vm._v("MATTHEW 1–2")])])])]), _vm._v(" "), _c('td', {
    staticClass: "tdhead"
  }, [_c('p', {
    staticClass: "t-lefta"
  }, [_c('strong', [_vm._v("LUKE 1–3")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jesus’ genealogy goes back to Abraham")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Jesus’ genealogy goes back to Adam")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joseph is the focus")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mary is the focus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herod the Great is introduced")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herod the Great is not mentioned")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Wise Men worship the Christ child")])]), _vm._v(" "), _c('td', {
    staticClass: "td1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Shepherds worship baby Jesus")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Yet, on the other hand, note the twelve major agreements between the birth stories of Matthew and Luke:")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.")]), _vm._v("Jesus’ birth is related to the reign of Herod (Matt. 2:1; Luke 1:5).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2.")]), _vm._v("Mary, his mother to be, is a virgin engaged to Joseph, but they have not yet come to live together (Matt. 1:18; Luke 1:27, 34; 2:5).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3.")]), _vm._v("Joseph is of the house of David (Matt. 1:16, 20; Luke 1:27; 2:4).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("4.")]), _vm._v("An angel from heaven announces the coming birth of Jesus (Matt. 1:20–21; Luke 1:28–30).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("5.")]), _vm._v("Jesus is recognized to be a Son of David (Matt. 1:1; Luke 1:32).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("6.")]), _vm._v("His conception is to take place through the Holy Spirit (Matt. 1:18, 20; Luke 1:35).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("7.")]), _vm._v("Joseph is not involved in the conception (Matt. 1:18–35; Luke 1:34).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("8.")]), _vm._v("The name “Jesus” is imposed by heaven prior to his birth (Matt. 1:21; Luke 1:31).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("9.")]), _vm._v("The angel identifies Jesus as “Savior” (Matt. 1:21; Luke 2:11).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("10.")]), _vm._v("Jesus is born after Mary and Joseph come to live together (Matt. 1:24–25; Luke 2:4–7).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("11.")]), _vm._v("Jesus is born in Bethlehem (Matt. 2:1; Luke 2:4–7).")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("12.")]), _vm._v("Jesus settles with Mary and Joseph in Nazareth in Galilee (Matt. 2:22–23; Luke 2:39, 51)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_10",
      "id": "fnote-10"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Actually, the differences in Matthew and Luke concerning the birth of Jesus Christ are easily accounted for once we allow for poetic license and their respective theological messages. Neither author purports to provide the complete account of the birth of their Lord but rather chooses which material to present according to the leading of the Holy Spirit and the spiritual needs of their audiences. Moreover, their agreement in the key areas we noted above corroborates their testimonies and would be accepted in a court of law today. Indeed, modern eyewitness accounts are deemed as legally reliable precisely because they agree in the basic descriptions rather than in the minutiae. In the case of the latter, such testimonies would be thrown out of court for collusion.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Supposed Historical Errors")])])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("But what about the accusation that the Gospels contain historical errors which thereby diminish their trustworthiness? Here we treat three famous texts supposedly guilty of blatant historical error. Mark 2:26 refers to King David eating showbread when ("), _c('em', [_vm._v("epi")]), _vm._v(") Abiathar was the high priest (see 1 Sam. 21:1–6). Yet, 1 Samuel 21 clearly states that Ahimelech, Abiathar’s father, held that office. It was this “mistake” that caused Bart Ehrman to jettison his conservative faith for liberalism."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_11",
      "id": "fnote-11"
    }
  }, [_vm._v("11")]), _vm._v(" But John Wenham has made a convincing case for translating the unusual prepositional phrase as, not “when Abiathar was high priest” but “concerning [the passage of Scripture in 1 Samuel 21 that speaks of] Abiathar the High Priest.” Indeed, Mark uses "), _c('em', [_vm._v("epi")]), _vm._v(" eighteen out of its twenty-one occurrences to refer to location not time. Wenham very plausibly suggests that Mark does this because the passage referred to comes immediately before Abiathar’s exploits as High Priest. In the context of the two priests—Ahimelech and Abiathar—the latter is the more noteworthy as the priest who first brought the priesthood to King David’s side in his struggle against Saul."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_12",
      "id": "fnote-12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Matthew 23:35 Jesus accuses the Jewish leaders of having a history of killing Old Testament righteous men, from Abel to Zechariah the son of Berachiah. Yet, the Old Testament says nothing of the prophet Zechariah being murdered. Skeptics of the Gospels seize on this point arguing that Jesus mistakenly confused the prophet Zechariah with another Zechariah, the son of Jehoiada, who was a priest. According to 2 Chronicles 24:20–22, the latter was killed in the temple court. However, rabbinic traditions (e.g., the "), _c('em', [_vm._v("Targum")]), _vm._v(" on Lam. 2:20 and the "), _c('em', [_vm._v("Midrash Rabbah")]), _vm._v(" on Eccl. 3:16) also refer to Zechariah the prophet as being killed in the temple. On this understanding, Jesus and extra-biblical tradition converge in reporting an actual incident not mentioned in the Old Testament. Other New Testament notables also refer to "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("individuals not recorded in the Hebrew Bible but mentioned in non-canonical Jewish literature."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_13",
      "id": "fnote-13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Luke 2:2 refers to a census taken during the time Quirinius was governor of Syria. Historians date that census to AD 6 but Jesus was born in 6 BC. Did Luke make a mistake here? Not if Quirinius was joint-ruler of Syria before he assumed sole governorship in AD 6, as some ancient Roman historians infer (Tacitus, "), _c('em', [_vm._v("Annals")]), _vm._v(" 3.48; Florus, "), _c('em', [_vm._v("Roman History")]), _vm._v(" 2.31)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_14",
      "id": "fnote-14"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("Supposed “Assured” Results of Higher-Critical Approaches")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A third reason for the modern skeptical appraisal of the historical reliability of the canonical gospels stems from three scholarly disciplines that dominated gospel studies in the twentieth century—source, form, and redaction criticisms. Each of these approaches in their own way have undermined the eyewitness claims of the Gospels. More than the previous suspicions raised against the Gospels (antipathy toward miracles and apparent contradictions and historical errors) these three disciplines have severed the Jesus of history from the Christ of faith. We first describe the three scholarly pursuits with a view to exposing how they eliminated the long-standing tradition by the church that the Gospels were based on eyewitness testimony and then in the chapters that follow we offer a rebuttal to each, arguing instead for the traditional view.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Source Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Source criticism has dominated gospel studies for the last two hundred years. Alternately labeled the “the Synoptic Problem,” B. H. Streeter is usually credited with popularizing this approach to the first three gospels."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_15",
      "id": "fnote-15"
    }
  }, [_vm._v("15")])]), _vm._v(" The central concern of the Synoptic Problem is how one is to account for both the similarities and the differences among Matthew, Mark, and Luke. Streeter’s work was the culmination of almost two thousand years of attempts to explain that question. His answer was that Mark was the first gospel written and that Matthew and Luke wrote independently of each other but had access to Mark’s gospel along with a hypothetical sayings source of Jesus’ teaching called “Q,” for "), _c('em', [_vm._v("Quelle")]), _vm._v(" (German for “source”), containing 235 sayings shared by Matthew and Luke. This “two document theory” was enlarged to include special Matthean material (“M”) and special Lukan material (“L”). Although rival configurations appeared along the way, Streeter’s theory has won the day. "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Now, the two source theory could be a useful tool to investigate the literary relationships among the Synoptics, but what threatened conservative scholars about this hypothesis was its oft-accompanying denial of the eyewitness nature of the three Gospels; a concern that was also applied to John. Simply put, the concern was this: why would Matthew, a disciple of Jesus, bother to use Mark, a non-disciple of Jesus, as well as the anonymous source “Q”? Luke might be expected to do as much since he was not an apostle. Yet, things got even more complicated because advocates of Streeter’s proposal went on to deny that even Matthew and John,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/#fnote_16",
      "id": "fnote-16"
    }
  }, [_vm._v("16")]), _vm._v(" two of the twelve apostles of Jesus, were actually the authors of those works ascribed to them. With those denials, the foundation of the eyewitness testimony of the four Gospels collapsed in the minds of many New Testament scholars.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Form Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Before the dust had settled on the debate concerning source criticism, in the 1920s form criticism assumed center stage as the newest approach to the Synoptic Gospels. Rudolf Bultmann was probably the most influential theologian in twentieth-century New Testament scholarship. Based on the works of his colleagues K. L. Schmidt and Martin Dibelius, Bultmann helped to pioneer the application of form criticism to the Gospels with the publication of his monumental work, "), _c('em', [_vm._v("The History of the Synoptic Tradition."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#fnote_17",
      "id": "fnote-17"
    }
  }, [_vm._v("17")])])]), _vm._v(" Three key components undergird the task of form criticism. (1) The gospel materials should be classified according to their “form”—parables, pronouncement stories, wisdom sayings, apocalyptic statements, miracles or legends, etc. (2) These forms circulated independently of each other in various church communities. For example, pronouncement stories were used in early Christian Jewish debates within the synagogues. Miracles/legends were appealed to by Gentile churches in an effort to win over Greek speaking audiences accustomed to hearing about divine-man miracle workers in their culture. And apocalyptic statements were developed by the early church in the aftermath of the delay of the parousia (the second coming of Jesus). (3) These forms first circulated among the believing communities in oral form and separate from each other for a generation before they were written down as the Gospels we now know. The fundamental assumption driving form criticism was that these materials were not produced by eyewitnesses but rather were the product of communities which had no real contact with the historical Jesus tradition. Indeed, after Bultmann applied the criteria of authenticity to the Gospels (most notably "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("the criteria of multiple attestation and dissimilarity—more on these later in this unit) there was precious little of the sayings and deeds attributed to Jesus that were deemed to be from the historical Jesus. Today, the Jesus Seminar continues Bultmann’s radical approach thus severing the Jesus of history from the Christ of faith.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("Redaction Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Coming on the heels of source and form criticisms, redaction criticism in the 1960s to the 1980s focused on the individual evangelists as shapers and editors of the material they inherited from their communities. While this discipline accorded more of a place to the theological efforts of the composers of the Gospels than did form criticism, it still questioned the Gospels as the products of eyewitness accounts. Instead of reporting the history of the real Jesus, the founders of redaction criticism (Günther Bornkamm, Willi Marxsen, and Hans Conzelmann) argued instead that the gospel authors were more interested in crafting their own theologies for their respective communities.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Space does not permit us in this opening chapter to respond to the above three disciplines and their combined attack on the historical reliability of the Gospels. Rather, in the chapters that follow in ")]), _c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part I")]), _vm._v(" we will offer our rebuttal to these criticisms.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("Summary")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We began our study with the fundamental question of whether the Jesus of history and the Christ of faith are the same. The decision one arrives at regarding this issue determines whether or not one views the canonical gospels as reliable, no small matter concerning the Christian faith. We began therefore to answer the three major criticisms raised against the four gospels. The evidence as we have studied it through the years has convinced us that the Gospels accurately record the supernatural acts of Jesus. They are historically reliable because the Gospels are indeed based on eyewitness accounts. Having done this, we now need to focus on more background information regarding the Gospels, specifically the three quests for the historical Jesus (see the next two Questions). To put our thesis another way, when we take the Gospels’ records seriously what picture of Jesus emerges?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2"
  }, [_vm._v("REFLECTION QUESTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.")]), _vm._v("What is the fundamental question of this chapter?")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2.")]), _vm._v("How would you answer the first objection to the reliability of the Gospels regarding miracles?")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3.")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("How would you answer the second objection of the reliability of the Gospels regarding their supposed contradictions and historical inaccuracies?")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("4.")]), _vm._v("How have the three New Testament disciplines of source, form, and redaction criticisms served to undermine the reliability of the Gospels?")])]), _c('p', {
    staticClass: "numlist"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("5.")]), _vm._v("How would you respond to these three disciplines?")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#fnote-1",
      "id": "fnote_1"
    }
  }, [_vm._v("1")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See David Hume, "), _c('em', [_vm._v("Enquiry Concerning Human Understanding")]), _vm._v(", ed. L. A. Selby-Bigge (1748 repr. Oxford: Clarendon, 1902), section 10.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-2",
      "id": "fnote_2"
    }
  }, [_vm._v("2")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("Paul Rhodes Eddy and Gregory A. Boyd, "), _c('em', [_vm._v("The Jesus Legend: A Case for the Historical Reliability of the Synoptic Jesus Tradition")]), _vm._v(" (Grand Rapids: Baker, 2007), 69.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-3",
      "id": "fnote_3"
    }
  }, [_vm._v("3")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See R. Mullin, "), _c('em', [_vm._v("Miracles and the Modern Religious Imagination")]), _vm._v(" (New Haven, CT: Yale University Press, 1996). Craig S. Keener has performed a valuable service in this regard by recording modern-day miracles in his "), _c('em', [_vm._v("Miracles: The Credibility of the New Testament Accounts")]), _vm._v(", 2 vols. (Grand Rapids: Baker, 2011).")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-4",
      "id": "fnote_4"
    }
  }, [_vm._v("4")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("Eddy and Boyd, "), _c('em', [_vm._v("Jesus Legend")]), _vm._v(", 74.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-5",
      "id": "fnote_5"
    }
  }, [_vm._v("5")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See Craig L. Blomberg, "), _c('em', [_vm._v("The Historical Reliability of the Gospels")]), _vm._v(", 2nd ed. (Downers Grove, IL: InterVarsity Press, 2007), 106.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-6",
      "id": "fnote_6"
    }
  }, [_vm._v("6")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("Ibid., 152.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-7",
      "id": "fnote_7"
    }
  }, [_vm._v("7")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("“The Chicago Statement on Inerrancy,” in "), _c('em', [_vm._v("Inerrancy")]), _vm._v(", ed. Norman L. Geisler (Grand Rapids: Zondervan, 1979).")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-8",
      "id": "fnote_8"
    }
  }, [_vm._v("8")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See, for example, the Sermon on the Mount (Matt. 5–7); the Olivet Discourse (Matt. 24); the Great Commission (Matt. 28).")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notesa"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-9",
      "id": "fnote_9"
    }
  }, [_vm._v("9")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("Blomberg, "), _c('em', [_vm._v("The Historical Reliability of the Gospels,")]), _vm._v(" 162–63.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-10",
      "id": "fnote_10"
    }
  }, [_vm._v("10")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("This material is adapted from Joseph A. Fitzmyer, "), _c('em', [_vm._v("The Gospel According to Luke I–IX")]), _vm._v(", AB 28 (New York: Doubleday, 1979), 307.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-11",
      "id": "fnote_11"
    }
  }, [_vm._v("11")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See Bart D. Ehrman, "), _c('em', [_vm._v("Misquoting Jesus: The Story Behind Who Changed the Bible and Why?")]), _vm._v(" (San Francisco: Harper-San Francisco, 2005), 9.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-12",
      "id": "fnote_12"
    }
  }, [_vm._v("12")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See J. W. Wenham, “Mark 2:26,” "), _c('em', [_vm._v("JTS")]), _vm._v(" (1950): 156.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-13",
      "id": "fnote_13"
    }
  }, [_vm._v("13")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("See, for example, Hebrews 11:35 with reference to 2 Maccabees and the Jewish mother’s hope for the resurrection of her martyred sons, Jude 9 concerning "), _c('em', [_vm._v("The Apocalypse of Moses")]), _vm._v(" and its mention of the dead body of Moses, or Jude 14–15 where Jude quotes "), _c('em', [_vm._v("1 Enoch")]), _vm._v(" with reference to the coming of the Lord.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-14",
      "id": "fnote_14"
    }
  }, [_vm._v("14")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("For further discussion, see C. Marvin Pate, "), _c('em', [_vm._v("Luke")]), _vm._v(" (Moody: Chicago, 1995), 24–25.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-15",
      "id": "fnote_15"
    }
  }, [_vm._v("15")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("B. H. Streeter, "), _c('em', [_vm._v("The Four Gospels: A Study of Origins")]), _vm._v(" (London: Macmillan, 1924; New York: Macmillan, 1925).")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-16",
      "id": "fnote_16"
    }
  }, [_vm._v("16")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("John came under scathing attack regarding its claim to be an eyewitness account due to being written in the 90s and containing much material that was different from the Synoptic Gospels.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#fnote-17",
      "id": "fnote_17"
    }
  }, [_vm._v("17")]), _vm._v("."), _c('span', {
    staticClass: "foot"
  }, [_vm._v("R. Bultmann, "), _c('em', [_vm._v("The History of the Synoptic Tradition")]), _vm._v(" (Oxford: Blackwell; New York: Harper & Row, 1968 [German orig. 1921]).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1efa967f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012_Chapter02.vue
// module id = 90
// module chunks = 0